import React, { useEffect, useState } from 'react';
import { CampoFormik } from '../../../CompUtils';
import es from '../../../../yup-es';
import * as yup from 'yup';
import { Formik } from 'formik';

import { Table } from 'react-bootstrap';
import { CONCURSOAPI, GREMIOS } from '../../../../const';
import axios from 'axios';

yup.setLocale(es);
const schema = yup
  .object({
    //MINTRA
    numeroSolicitudMintra: yup.string(),
    fechaSolicitudMintra: yup.date(),
    fechaRespuestaMintra: yup.date(),
    numeroRespuestaMintra: yup.string(),
    //MINMUJ
    numeroSolicitudMinmuj: yup.string(),
    fechaSolicitudMinmuj: yup.date(),
    fechaRespuestaMinmuj: yup.date(),
    numeroRespuestaMinmuj: yup.string(),
    //ATE
    numeroSolicitudAte: yup.string(),
    fechaSolicitudAte: yup.date(),
    fechaRespuestaAte: yup.date(),
    numeroRespuestaAte: yup.string(),
    //UPCN
    numeroSolicitudUpcn: yup.string(),
    fechaSolicitudUpcn: yup.date(),
    fechaRespuestaUpcn: yup.date(),
    numeroRespuestaUpcn: yup.string(),
  })
  .shape(
    {
      fechaRespuestaUpcn: yup.date().when('numeroRespuestaUpcn', {
        is: (numeroRespuestaUpcn) => !!numeroRespuestaUpcn,
        then: yup.date().required(),
      }),

      numeroRespuestaUpcn: yup.string().when('fechaRespuestaUpcn', {
        is: (fechaRespuestaUpcn) => fechaRespuestaUpcn,
        then: yup.string().required(),
      }),
    },
    ['numeroRespuestaUpcn', 'fechaRespuestaUpcn'],
  )
  .shape(
    {
      fechaSolicitudUpcn: yup.date().when('numeroSolicitudUpcn', {
        is: (numeroSolicitudUpcn) => !!numeroSolicitudUpcn,
        then: yup.date().required(),
      }),

      numeroSolicitudUpcn: yup.string().when('fechaSolicitudUpcn', {
        is: (fechaSolicitudUpcn) => fechaSolicitudUpcn,
        then: yup.string().required(),
      }),
    },
    ['numeroSolicitudUpcn', 'fechaSolicitudUpcn'],
  )
  .shape(
    {
      fechaRespuestaAte: yup.date().when('numeroRespuestaAte', {
        is: (numeroRespuestaAte) => !!numeroRespuestaAte,
        then: yup.date().required(),
      }),

      numeroRespuestaAte: yup.string().when('fechaRespuestaAte', {
        is: (fechaRespuestaAte) => fechaRespuestaAte,
        then: yup.string().required(),
      }),
    },
    ['numeroRespuestaAte', 'fechaRespuestaAte'],
  )
  .shape(
    {
      fechaSolicitudAte: yup.date().when('numeroSolicitudAte', {
        is: (numeroSolicitudAte) => !!numeroSolicitudAte,
        then: yup.date().required(),
      }),

      numeroSolicitudAte: yup.string().when('fechaSolicitudAte', {
        is: (fechaSolicitudAte) => fechaSolicitudAte,
        then: yup.string().required(),
      }),
    },
    ['numeroSolicitudAte', 'fechaSolicitudAte'],
  )
  .shape(
    {
      fechaRespuestaMinmuj: yup.date().when('numeroRespuestaMinmuj', {
        is: (numeroRespuestaMinmuj) => !!numeroRespuestaMinmuj,
        then: yup.date().required(),
      }),

      numeroRespuestaMinmuj: yup.string().when('fechaRespuestaMinmuj', {
        is: (fechaRespuestaMinmuj) => fechaRespuestaMinmuj,
        then: yup.string().required(),
      }),
    },
    ['numeroRespuestaMinmuj', 'fechaRespuestaMinmuj'],
  )
  .shape(
    {
      fechaSolicitudMinmuj: yup.date().when('numeroSolicitudMinmuj', {
        is: (numeroSolicitudMinmuj) => !!numeroSolicitudMinmuj,
        then: yup.date().required(),
      }),

      numeroSolicitudMinmuj: yup.string().when('fechaSolicitudMinmuj', {
        is: (fechaSolicitudMinmuj) => fechaSolicitudMinmuj,
        then: yup.string().required(),
      }),
    },
    ['numeroSolicitudMinmuj', 'fechaSolicitudMinmuj'],
  )
  .shape(
    {
      fechaSolicitudMintra: yup.date().when('numeroSolicitudMintra', {
        is: (numeroSolicitudMintra) => !!numeroSolicitudMintra,
        then: yup.date().required(),
      }),

      numeroSolicitudMintra: yup.string().when('fechaSolicitudMintra', {
        is: (fechaSolicitudMintra) => fechaSolicitudMintra,
        then: yup.string().required(),
      }),
    },
    ['numeroSolicitudMintra', 'fechaSolicitudMintra'],
  )
  .shape(
    {
      fechaRespuestaMintra: yup.date().when('numeroRespuestaMintra', {
        is: (numeroRespuestaMintra) => !!numeroRespuestaMintra,
        then: yup.date().required(),
      }),

      numeroRespuestaMintra: yup.string().when('fechaRespuestaMintra', {
        is: (fechaRespuestaMintra) => fechaRespuestaMintra,
        then: yup.string().required(),
      }),
    },
    ['numeroRespuestaMintra', 'fechaRespuestaMintra'],
  );

const SolicitudRespuestaVeedores = ({
  solicitudVeedoresDTO = {},
  soliditudRespuestaRecibida = null,
}) => {
  const [solicitud, setSolicitud] = useState(soliditudRespuestaRecibida);

  function handleChangeField(field, value) {
    solicitud[field] = value;
    solicitudVeedoresDTO(solicitud);
  }
  useEffect(() => {}, []);

  return (
    <>
      <h3 className="text-center">Nota Solicitud y Respuesta</h3>
      <Formik validationSchema={schema} validateOnChange={false} initialValues={solicitud}>
        {(formik) => {
          return (
            <Table>
              <thead>
                <tr>
                  <th className="text-center"></th>
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Número Solicitud</th>
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Número Respuesta</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">
                    <h5>{GREMIOS.MINTRA}</h5>
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaSolicitudMintra"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaSolicitudMintra',
                        formik.values.fechaSolicitudMintra,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="numeroSolicitudMintra"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroSolicitudMintra',
                        formik.values.numeroSolicitudMintra,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaRespuestaMintra"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaRespuestaMintra',
                        formik.values.fechaRespuestaMintra,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="numeroRespuestaMintra"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroRespuestaMintra',
                        formik.values.numeroRespuestaMintra,
                      )}
                    />
                  </td>
                </tr>

                <tr>
                  <td className="align-middle">
                    <h5>{GREMIOS.MINMUJ}</h5>
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaSolicitudMinmuj"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaSolicitudMinmuj',
                        formik.values.fechaSolicitudMinmuj,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="numeroSolicitudMinmuj"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroSolicitudMinmuj',
                        formik.values.numeroSolicitudMinmuj,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaRespuestaMinmuj"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaRespuestaMinmuj',
                        formik.values.fechaRespuestaMinmuj,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="numeroRespuestaMinmuj"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroRespuestaMinmuj',
                        formik.values.numeroRespuestaMinmuj,
                      )}
                    />
                  </td>
                </tr>

                <tr>
                  <td className="align-middle">
                    <h5>{GREMIOS.ATE}</h5>
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaSolicitudAte"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaSolicitudAte',
                        formik.values.fechaSolicitudAte,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="numeroSolicitudAte"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroSolicitudAte',
                        formik.values.numeroSolicitudAte,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaRespuestaAte"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaRespuestaAte',
                        formik.values.fechaRespuestaAte,
                      )}
                    />
                  </td>
                  <td>
                    {' '}
                    <CampoFormik
                      name="numeroRespuestaAte"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroRespuestaAte',
                        formik.values.numeroRespuestaAte,
                      )}
                    />
                  </td>
                </tr>

                <tr>
                  <td className="align-middle">
                    <h5>{GREMIOS.UPCN}</h5>
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaSolicitudUpcn"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaSolicitudUpcn',
                        formik.values.fechaSolicitudUpcn,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="numeroSolicitudUpcn"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroSolicitudUpcn',
                        formik.values.numeroSolicitudUpcn,
                      )}
                    />
                  </td>
                  <td>
                    <CampoFormik
                      name="fechaRespuestaUpcn"
                      type="date"
                      formik={formik}
                      onChange={handleChangeField(
                        'fechaRespuestaUpcn',
                        formik.values.fechaRespuestaUpcn,
                      )}
                    />
                  </td>
                  <td>
                    {' '}
                    <CampoFormik
                      name="numeroRespuestaUpcn"
                      formik={formik}
                      onChange={handleChangeField(
                        'numeroRespuestaUpcn',
                        formik.values.numeroRespuestaUpcn,
                      )}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          );
        }}
      </Formik>
    </>
  );
};
export default SolicitudRespuestaVeedores;
